/** @file Finds a sector table by id: the puppet's own tables first, then the built-ins. */
import { SECTOR_TABLES } from '@zilo/pose3d-format/tables/sectorTables';
import type { SectorTable } from '@zilo/pose3d-format/types/facet';
import type { Puppet } from '@zilo/pose3d-format/types/puppet';

/** The table `id` names for `puppet`, or undefined. */
export function resolveSectorTable(id: string, puppet: Pick<Puppet, 'sectorTables'>): SectorTable | undefined {
  const own = puppet.sectorTables;
  if (own !== undefined && Object.hasOwn(own, id)) return own[id];
  return Object.hasOwn(SECTOR_TABLES, id) ? SECTOR_TABLES[id] : undefined;
}
